<section class="bg-secondary-subtle section-inset-y content-block-agenda">
  <header
    class="section-header container"
    [class.pt-header-card-slider]="headerType() === 'header-card-slider'"
    [class.pt-header-search]="headerType() === 'header-library'"
  >
    <div class="section-header__main">
      @if (block().subtitle) {
        <strong class="fs-body-md fw-semi mb-2 text-primary d-inline-block w-100">{{ block().subtitle }}</strong>
      }
      @if (block().title) {
        <h2 class="h4">{{ block().title }}</h2>
      }
    </div>

    <a [routerLink]="['/agenda']" [queryParams]="block().queryParams" class="button button--secondary">Bekijk agenda</a>
  </header>

  <app-event-card-slider [events]="block().events || []" [cookiePreferences]="cookiePreferences()"></app-event-card-slider>
</section>
